import {StyleSheet} from 'react-native';

import {cloudLightest, white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    flex: 1,
    backgroundColor: white,
    overflow: 'hidden',
    overflowY: 'hidden',
    overflowX: 'hidden',
  } as any,
  heading: {
    paddingBottom: 20,
  },
  orderNumberContainer: {
    flexDirection: 'row',
  },
  loading: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: white,
  },
  loadingIndicator: {
    paddingBottom: 100,
  },
  webScrollContainer: {
    flex: 1,
    minHeight: 0,
    height: '100%',
    maxHeight: '100dvh',
    overflowY: 'scroll',
    overflowX: 'hidden',
    WebkitOverflowScrolling: 'touch',
    overscrollBehavior: 'contain',
  } as any,
  sections: {
    paddingBottom: 60,
    backgroundColor: cloudLightest,
  },
});
